import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sgc-privacy',
    templateUrl: './sgc-privacy.component.html',
    styleUrls: ['./sgc-privacy.component.css'],
    standalone: false
})
export class SgcPrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
